<div class="detail-section-header">Systemoplysninger</div>
<table class="detail-table">
  <tr>
    <td class="detail-label">Letsikring id</td>
    <td>{{ letsikring().id }}</td>
  </tr>
  <tr>
    <td class="detail-label">Risikodækning</td>
    <td>{{ !!risiko() | boolean }}</td>
  </tr>
  <tr>
    <td class="detail-label">Systemdetaljer</td>
    <td>{{ revision().systemDetaljer }}</td>
  </tr>
</table>
